// import HeartAnimation from "../classes/HeartAnimation";
import React, { useState, useRef, useEffect } from "react";
import { gsap } from 'gsap';
import { CustomEase} from 'gsap/CustomEase';
import { CustomWiggle} from 'gsap/CustomWiggle';
import HeartSvg from "./HeartSvg";

function HeartAnimation({ goalRef, onInView, showHeart, setShowHeart }) {
    const ref = useRef(null);
    const [started, setStarted] = useState(false);
    const fadeClass = started ? "fade-out ready" : "";

    const copyHearts = (selector, quantity, parentElem) => {
      const el = parentElem.querySelector(selector);

      const parent = el.parentNode;
      const type = el.nodeName;
      const array = [];
      let child;

      while (--quantity > -1) {
        child = document.createElement(type);
        parent.insertBefore(child, el);
        array.push(child);
        child.outerHTML = el.outerHTML;
      }
      return array;
    };

    const duration = 1.75;
    const pause = 0.5;
    const delay = duration / 2;

    const pulseAnimation = (element, parentElem) => {
      const timeline = gsap.timeline();
      const el = parentElem.querySelector(element);

      timeline
        .to(el, {
          duration: delay,
          ease: "linear",
          repeat: -1,
          scale: 1.2,
          transformOrigin: "bottom center",
          yoyo: true
        });

      return timeline;
    };

    const floatAnimation = (elements, x, parentElem) => {
      let els = parentElem.querySelectorAll(elements);
      let i = els.length;

      els = gsap.utils.toArray(els);
      const timeline = gsap.timeline({
        repeat: 1,
        duration: 3.5,
        repeatRefresh: true
      });

      while (--i > -1) {
        const overlap = i < els.length ? "-=1.5" : "0";
        timeline
          .addLabel(`start${i}`, overlap)
          .set(els[i], {
            autoAlpha: 1
          }, `start${i}`)
          .to(els[i], {
            duration,
            ease: "wiggle(6)",
            x: "+=" + gsap.utils.random(-x, x)
          }, `start${i}`)
          .to(els[i], {
            duration,
            scale: 0,
            yPercent: -400
          }, `start${i}`)
          .set(els[i], {
            scale: 1,
            xPercent: 0,
            yPercent: 0
          });
      }

      return timeline;
    };

    useEffect(() => {
      if (started || !ref.current) {
        // Animation Started - Cancel function
        return;
      }

      const unsubscribe = onInView(() => {
        setStarted(true);
        gsap.timeline()
          .add(copyHearts(".heart--simple", 6, ref.current))
          .addLabel("start")
          .add(pulseAnimation("#heart", ref.current), "start")
          .add(floatAnimation(".heart--simple", 30, ref.current), "start");
        setTimeout(() => setShowHeart(false), 15 * 1000);
        unsubscribe();
      });

      return () => {
        unsubscribe();
      };
    }, [ref, goalRef, started, onInView]);

    if (!showHeart) {
      return null;
    }

    return (
      <div ref={ref} id={`heart-animation-${goalRef}`} className={`heart-animation__wrapper ${fadeClass}`}>
        <HeartSvg goalRef={goalRef} />
      </div>
    );
}

export default HeartAnimation;